import { createApp } from 'vue'
import App from './App.vue'

// Function to initialize the app with optional configuration
// Only called manually from WordPress - no auto-mounting
function initRacingTrackerApp(elementId = '#app', config = {}) {
  // Get mode from config or default to 'bb'
  const mode = config.mode || 'bb'
  const userId = config.userId || null
  
  const app = createApp(App, {
    initialMode: mode,
    initialUserId: userId
  })
  
  app.mount(elementId)
  
  return app
}

// Export for WordPress embedding
if (typeof window !== 'undefined') {
  window.initRacingTrackerApp = initRacingTrackerApp
}